<template>
  <div class="mb-4">
    <p class="text-sm font-semibold mb-2">{{ $t("visibility") }}</p>
    <div class="flex flex-col gap-2">
      <div
        v-for="option in privacyOptions"
        :key="option.value"
        class="flex items-center gap-3 p-3 border rounded-lg cursor-pointer duration-200"
        :class="
          selectedValue === option.value
            ? 'border-primary bg-primary/5'
            : 'border-surface-300 dark:border-surface-700 hover:border-primary/50'
        "
        role="button"
        @click="emit('update:modelValue', option.value)"
      >
        <i
          :class="[
            option.icon,
            selectedValue === option.value ? 'text-primary' : 'text-surface-500',
          ]"
          class="text-base"
        />
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium leading-tight">{{ option.label }}</p>
          <p class="text-xs text-surface-500 dark:text-surface-400 mt-0.5">
            {{ option.description }}
          </p>
        </div>
        <i
          v-if="selectedValue === option.value"
          class="pi pi-check-circle text-primary"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type YouTubePrivacyStatus = "public" | "private" | "unlisted";

const props = defineProps<{
  modelValue?: YouTubePrivacyStatus;
}>();

const selectedValue = computed(() => props.modelValue ?? "public");

const emit = defineEmits<{
  "update:modelValue": [value: YouTubePrivacyStatus];
}>();

const privacyOptions: {
  value: YouTubePrivacyStatus;
  label: string;
  description: string;
  icon: string;
}[] = [
  {
    value: "public",
    label: "Public",
    description: "Anyone can search for and view this video",
    icon: "pi pi-globe",
  },
  {
    value: "unlisted",
    label: "Unlisted",
    description: "Anyone with the link can view this video",
    icon: "pi pi-link",
  },
  {
    value: "private",
    label: "Private",
    description: "Only you can view this video",
    icon: "pi pi-lock",
  },
];
</script>
